import { FC, useEffect } from "react";
import { useAppDispatch, useAppSelector } from "app/hooks";
import { getSurveySection } from "app/features/surveySlice";
import { questionIds } from "../../constants/initialValues";
import Typography from "@mui/material/Typography";
import { getStates, getCities, cleanCities } from "app/features/surveySlice";
import { FormControlModel } from "types";
import { ElementType } from "lib/enums/enums";
import FormComponentFactory from "lib/factory/FormComponentFactory";
import { NO_SAVING, TRUE } from "pages/SurveyForm/constants/uiControls";
import StepContent from "../StepContent";

type Props = {
  formik: any;
  sectionId: number;
};

const Step2: FC<Props> = ({ formik, sectionId }) => {
  const dispatch = useAppDispatch();
  const { states, cities, surveySection } = useAppSelector((state: any) => state.survey) ?? [];
  const { questions = [] } = surveySection || {};
  const gender = questions[0] ?? [];
  const places = questions[1]?.subQuestions ?? [];

  const stateTriggerId: string = questionIds.step2.birthCountry || "";
  const cityTriggerId: string = questionIds.step2.birthState || "";
  const countryKey = formik.values.birthCountry?.value;
  const stateKey = formik.values.birthState?.value;
  const cityKey = formik.values.birthCity?.value;

  const onCleanCities = () => {
    formik.setFieldValue("birthCity", {});
    formik.setFieldTouched("birthCity", true, false);
  };

  const onSelectCountry = (searchId: string) => {
    dispatch(getStates({ triggerId: stateTriggerId, searchId }));
    dispatch(cleanCities());
    onCleanCities();
  };

  const onSelectState = (searchId: string) => {
    dispatch(getCities({ triggerId: cityTriggerId, searchId }));
  };

  useEffect(() => {
    dispatch(getSurveySection(sectionId));
  }, []);

  useEffect(() => {
    if (stateTriggerId && countryKey) dispatch(getStates({ triggerId: stateTriggerId, searchId: countryKey }));
  }, [stateTriggerId && countryKey]);

  useEffect(() => {
    if (stateKey) {
      dispatch(getStates({ triggerId: stateTriggerId, searchId: countryKey }));
      dispatch(getCities({ triggerId: cityTriggerId, searchId: stateKey }));
    }
  }, [stateKey, cityKey]);

  const onBirthDateError = (name: string) => {
    formik.setFieldTouched(name, true, false);
  };

  const clearFieldsConditioned = (value: string) => {
    if (value === NO_SAVING) {
      formik.setFieldValue("sisbenCategory", { ...formik?.values?.sisbenCategory, value: "" });
    }
  };

  const dataModel: FormControlModel[] = [
    {
      formik,
      key: 0,
      visible: true,
      name: "gender",
      questionData: gender,
      label: "Género del colaborador",
      elementType: ElementType.Select,
    },
    {
      key: 1,
      formik,
      visible: true,
      name: "birthCountry",
      questionData: places[0],
      elementType: ElementType.Select,
      onChangeCallback: onSelectCountry,
      label: "País de nacimiento del colaborador",
    },
    {
      key: 2,
      formik,
      visible: true,
      name: "birthState",
      elementType: ElementType.Select,
      onChangeCallback: onSelectState,
      label: "Departamento de nacimiento",
      questionData: { source: states, id: questionIds.step2.birthState },
    },
    {
      key: 3,
      formik,
      visible: true,
      name: "birthCity",
      elementType: ElementType.Select,
      label: "Municipio de nacimiento",
      questionData: { source: cities, id: questionIds.step2.birthCity },
    },
    {
      key: 4,
      formik,
      visible: true,
      name: "birthDate",
      label: "Fecha de nacimiento",
      onBlurCallback: onBirthDateError,
      elementType: ElementType.DatePicker,
      questionData: { source: cities, id: questionIds.step2.birthDate },
    },
    {
      key: 5,
      formik,
      visible: true,
      label: "Estado civil",
      name: "maritalStatus",
      questionData: questions[3],
      elementType: ElementType.Select,
    },
    {
      key: 6,
      formik,
      visible: true,
      name: "socialGroups",
      questionData: questions[4],
      elementType: ElementType.Select,
      label: "¿Se identifica con alguno de estos grupos poblacionales vulnerables?",
    },
    {
      key: 7,
      formik,
      visible: true,
      name: "sisben",
      questionData: questions[5],
      elementType: ElementType.Radio,
      label: "¿Cuenta con registro SISBEN?",
      onChangeCallback: clearFieldsConditioned,
    },
    {
      key: 8,
      formik,
      name: "sisbenCategory",
      elementType: ElementType.Select,
      questionData: questions[5]?.subQuestions[0],
      visible: formik.values.sisben?.value === TRUE,
      label: "¿En qué categoría de SISBEN está clasificado?",
    },
  ];
  return (
    <div>
      <Typography mb={2} variant='subtitle1' align='center'>
        Información general
      </Typography>
      <StepContent>{dataModel.map(FormComponentFactory)}</StepContent>
    </div>
  );
};

export default Step2;
